import * as React from "react";
function SvgViewOff(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.201 12a15.803 15.803 0 001.964 2.276C7.662 15.702 9.675 17 12 17c1.04 0 2.016-.26 2.912-.674l-.88-.88a4 4 0 01-5.478-5.478l-1.23-1.23c-.413.311-.801.645-1.16.986A15.812 15.812 0 004.202 12zM7.6 6.185L4.707 3.293 3.293 4.707 5.9 7.313c-.405.316-.777.642-1.114.963a17.81 17.81 0 00-2.453 2.913 10.498 10.498 0 00-.173.27l-.011.018-.003.005-.002.002c0 .001 0 .002.857.516l-.857-.514-.31.514.31.514L3 12l-.857.515.002.003.003.005.01.018a7.364 7.364 0 00.174.27 17.81 17.81 0 002.453 2.913C6.438 17.298 8.925 19 12 19c1.649 0 3.128-.49 4.4-1.185l2.893 2.892 1.414-1.414-2.605-2.606c.404-.316.776-.642 1.113-.963a17.815 17.815 0 002.453-2.913 10.14 10.14 0 00.174-.27l.01-.018.004-.005v-.002h.001c0-.001 0-.002-.857-.516l.858.514.308-.514-.308-.514L21 12c.858-.514.857-.515.857-.515l-.001-.003-.004-.005-.01-.018a7.346 7.346 0 00-.174-.27 17.817 17.817 0 00-2.453-2.913C17.562 6.702 15.075 5 12 5c-1.648 0-3.128.49-4.4 1.185zm1.488 1.488C9.984 7.26 10.96 7 12 7c2.325 0 4.338 1.298 5.835 2.724A15.81 15.81 0 0119.8 12a15.802 15.802 0 01-1.964 2.276c-.358.34-.745.675-1.16.985l-1.229-1.23a4 4 0 00-5.478-5.478l-.88-.88zm2.394 2.395a2.001 2.001 0 012.45 2.45l-2.45-2.45zm-1.414 1.414l2.45 2.45A2.004 2.004 0 0110 12a2 2 0 01.068-.518z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgViewOff);
export default ForwardRef;
